<div *ngIf="!dialogData?.fromDialog">
  <mat-card>
    <form [formGroup]="newCommuniqueForm">
      <div class="row">
        <div class="col-md-6">
          <mat-label class="required-field">
            {{ "communique.to" | translate }}
          </mat-label>
          <dg-employee-search
            [empConfig]="empConfigTo"
            [orgConfig]="orgConfig"
            [showFilter]="true"
            [showEmpIdDsgnName]="false"
            [selectedEmployeeList]="toList"
            [isDisplayLoginEmp]="false"
            (output)="getData2toEmployee($event)"
            #empSearch4
          >
          </dg-employee-search>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-label>{{ "communique.cc" | translate }}</mat-label>
          <dg-employee-search
            [empConfig]="empConfig"
            [orgConfig]="orgConfig"
            [showFilter]="true"
            [showEmpIdDsgnName]="false"
            [selectedEmployeeList]="ccList"
            [isDisplayLoginEmp]="false"
            (output)="getData2ccEmployee($event)"
            #empSearch5
          >
          </dg-employee-search>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-label>{{ "communique.bcc" | translate }}</mat-label>
          <dg-employee-search
            [empConfig]="empConfig"
            [orgConfig]="orgConfig"
            [showFilter]="true"
            [showEmpIdDsgnName]="false"
            [selectedEmployeeList]="bccList"
            [isDisplayLoginEmp]="false"
            (output)="getData2bcc($event)"
            #empSearch6
          >
          </dg-employee-search>
        </div>
      </div>
      <div class="row">
        <mat-form-field>
          <mat-label>{{ "communique.subject" | translate }} </mat-label>
          <input type="text" matInput formControlName="subject" />
          <mat-error></mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-label class="required-field">
          {{ "communique.communique_details" | translate }}
        </mat-label>
        <ckeditor
          [readOnly]="false"
          formControlName="communiqueDetails"
          [config]="editorConfig1"
        >
        </ckeditor>
      </div>

      <!--checkbox-->
      <div class="mt-3 row col-md-12">
        <div class="col-md-3" *ngFor="let option of communiqueTypes">
          <!-- <div class="col-md-4"> -->
          <!--  <mat-checkbox
              [(ngModel)]="option.value"
              (change)="updateSelectedOption(option.id, $event.checked)"
            >
              {{ option.label }}
            </mat-checkbox> -->
          <label>
            <input
              type="checkbox"
              class="custom-input"
              (change)="updateSelectedOption(option.id, $event)"
              [checked]="option.value"
              [disabled]="option.disabled"
            />
            {{ option.label }}
          </label>
          <!--   </div> -->
        </div>
      </div>
      <div class="row">
        <mat-label>{{ "communique.category" | translate }}</mat-label>
        <mat-radio-group
          aria-label="Select an option"
          formControlName="category"
          class="d-flex"
        >
          <mat-radio-button
            *ngFor="let a of array"
            [value]="a.id"
            [checked]="a.checked"
            (change)="onCategoryChange($event)"
          >
            {{ a.name }}
          </mat-radio-button>
          <mat-error> </mat-error>
        </mat-radio-group>
      </div>
      <div class="row" *ngIf="showTimePicker">
        <mat-form-field>
          <mat-label>
            {{ "communique.expected_closure_date" | translate }}
          </mat-label>
          <input
            [min]="minDate"
            matInput
            [ngxMatDatetimePicker]="picker"
            formControlName="expectedClosureDt"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <ngx-mat-datetime-picker
            #picker
            [showSeconds]="true"
          ></ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
      <div class="row">
        <dg-file-upload
          [multiple]="multipleAllowed"
          [edit]="isEdit"
          [acceptedType]="appAcceptedType"
          [attachId]="appAttachID"
          [maxSize]="appMaxSize"
          [maxfiles]="appMaxFiles"
          (finalPath)="onFinalPathInitial($event)"
          [title]="'Attachments(s)'"
          [uniqueAttachmentId]="attachmentID"
          [allowUpdate]="isAllowUpdate"
          [allowFileToAttach]="isAllowFileToAttach"
          [allowDelete]="isAllowDelete"
          [mandatory]="isMandatory"
          [attachSmall]="attachSmall"
          [refreshAttachComponent]="isRefresh"
          [isDownload]="true"
        >
        </dg-file-upload>
      </div>
    </form>

    <mat-dialog-actions class="dg-btn">
      <button
        mat-raised-button
        class="me-2"
        color="primary"
        (click)="onSubmitClick()"
        [disabled]="newCommuniqueForm?.invalid || !isAttachmentAdded"
      >
        {{ "communique.submit" | translate }}
      </button>

      <button
        mat-raised-button
        class="me-2"
        color="primary"
        (click)="onSaveAsDraftClick()"
      >
        {{ "communique.save_draft" | translate }}
      </button>
      <button mat-flat-button class="me-2" (click)="onCancel()">
        {{ "communique.cancel" | translate }}
      </button>
    </mat-dialog-actions>
  </mat-card>
</div>

<div *ngIf="dialogData?.fromDialog">
  <h1 mat-dialog-title>
    {{ dialogData.title }}
  </h1>
  <mat-card>
    <form [formGroup]="newCommuniqueForm">
      <div class="row">
        <div class="col-md-6">
          <mat-label class="required-field">
            {{ "communique.to" | translate }}
          </mat-label>
          <dg-employee-search
            [empConfig]="empConfigTo"
            [orgConfig]="orgConfig"
            [showFilter]="true"
            [showEmpIdDsgnName]="false"
            [showAllEmps]="false"
            [isDisplayLoginEmp]="false"
            [selectedEmployeeList]="toList"
            (output)="getData2toEmployee($event)"
            #empSearch
          >
          </dg-employee-search>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-label>{{ "communique.cc" | translate }}</mat-label>
          <dg-employee-search
            [empConfig]="empConfig"
            [orgConfig]="orgConfig"
            [showFilter]="true"
            [showAllEmps]="false"
            [showEmpIdDsgnName]="false"
            [isDisplayLoginEmp]="false"
            [selectedEmployeeList]="ccList"
            (output)="getData2ccEmployee($event)"
            #empSearch1
          >
          </dg-employee-search>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-label>{{ "communique.bcc" | translate }}</mat-label>
          <dg-employee-search
            [empConfig]="empConfig"
            [orgConfig]="orgConfig"
            [showFilter]="true"
            [showAllEmps]="false"
            [showEmpIdDsgnName]="false"
            [isDisplayLoginEmp]="false"
            [selectedEmployeeList]="bccList"
            (output)="getData2bcc($event)"
            #empSearch2
          >
          </dg-employee-search>
        </div>
      </div>
      <div class="row">
        <mat-form-field>
          <mat-label>{{ "communique.subject" | translate }} </mat-label>
          <input type="text" matInput formControlName="subject" />
          <mat-error></mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-label class="required-field">
          {{ "communique.communique_details" | translate }}
        </mat-label>
        <ckeditor
          [readOnly]="false"
          formControlName="communiqueDetails"
          [config]="editorConfig1"
        >
        </ckeditor>
      </div>

      <div class="row">
        <mat-label>{{ "communique.category" | translate }}</mat-label>
        <mat-radio-group
          aria-label="Select an option"
          formControlName="category"
          class="d-flex"
        >
          <mat-radio-button
            *ngFor="let a of array"
            [value]="a.id"
            [checked]="a.checked"
            (change)="onCategoryChange($event)"
          >
            {{ a.name }}
          </mat-radio-button>
          <mat-error> </mat-error>
        </mat-radio-group>
      </div>
      <div class="row" *ngIf="showTimePicker">
        <mat-form-field>
          <mat-label>
            {{ "communique.expected_closure_date" | translate }}
          </mat-label>
          <input
            [min]="minDate"
            matInput
            [ngxMatDatetimePicker]="picker"
            formControlName="expectedClosureDt"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <ngx-mat-datetime-picker
            #picker
            [showSeconds]="true"
          ></ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
      <div class="row">
        <dg-file-upload
          [multiple]="multipleAllowed"
          [edit]="isEdit"
          [acceptedType]="appAcceptedType"
          [attachId]="appAttachID"
          [maxSize]="appMaxSize"
          [maxfiles]="appMaxFiles"
          (finalPath)="onFinalPath($event)"
          [title]="'Attachments(s)'"
          [uniqueAttachmentId]="attachmentID"
          [allowUpdate]="isAllowUpdate"
          [allowFileToAttach]="isAllowFileToAttach"
          [allowDelete]="isAllowDelete"
          [mandatory]="isMandatory"
          [attachSmall]="attachSmall"
          [refreshAttachComponent]="isRefresh"
          [refreshComponent]="refreshComponent"
          [isDownload]="true"
        >
        </dg-file-upload>
      </div>
    </form>
  </mat-card>
  <mat-dialog-actions class="dg-btn">
    <button
      *ngIf="!this.dialogData.data?.isFromReplyWithOutAttachment"
      mat-raised-button
      class="me-2"
      color="primary"
      (click)="onSubmitClick()"
      [disabled]="newCommuniqueForm?.invalid || !isAttachmentAttached"
    >
      {{ "communique.submit" | translate }}
    </button>
    <button
      *ngIf="this.dialogData.data?.isFromReplyWithOutAttachment"
      mat-raised-button
      class="me-2"
      color="primary"
      (click)="onSubmitClick()"
      [disabled]="newCommuniqueForm?.invalid"
    >
      {{ "communique.submit" | translate }}
    </button>
    <button
      mat-raised-button
      class="me-2"
      color="primary"
      (click)="onSaveAsDraftClick()"
    >
      {{ "communique.save_draft" | translate }}
    </button>
    <button mat-flat-button class="me-2" [mat-dialog-close]="true">
      {{ "communique.cancel" | translate }}
    </button>
  </mat-dialog-actions>
</div>
